import React from 'react';

export const SectionLinks = (props) => {

    if(!props.data) return null;
    
    return(
        <div className="row">
            <ul className="list-unstyled">
                {props.data.map((x,i) => { return <li className="col-md-4" key={i}><a onClick={props.onClick.bind(null, x.section, x.title)} href={x.link}>{x.title}</a></li> })}
            </ul>
        </div>
    )
}